import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/landing/Logo";

const SECTIONS = [
  {
    title: "1. Tentang KalkuBisnis",
    body: "KalkuBisnis adalah aplikasi web yang membantu pelaku usaha menghitung biaya pokok (HPP), menentukan harga jual, memperkirakan titik impas (BEP), dan mencatat penjualan. Aplikasi diakses melalui browser di HP atau komputer dengan koneksi internet.",
  },
  {
    title: "2. Pembayaran Satu Kali",
    body: "Pembelian KalkuBisnis dilakukan dengan satu kali pembayaran. Tidak ada biaya langganan bulanan maupun biaya perpanjangan tahunan yang wajib dibayarkan.",
  },
  {
    title: "3. Masa Akses Layanan",
    body: "Akses akun tetap tersedia selama layanan KalkuBisnis beroperasi. Kami tidak menjanjikan ketersediaan layanan seumur hidup atau waktu operasional tanpa gangguan sama sekali.",
  },
  {
    title: "4. Aktivasi Akun",
    body: "Pembuatan akun dilakukan secara manual oleh administrator setelah pembayaran terverifikasi. Informasi akses akan dikirimkan menggunakan data kontak yang tersedia pada pesananmu.",
  },
  {
    title: "5. Satu Akun untuk Satu Usaha",
    body: "Setiap akun KalkuBisnis dimaksudkan untuk digunakan oleh satu usaha. Mohon gunakan akun sesuai peruntukannya.",
  },
  {
    title: "6. Tanggung Jawab Pengguna",
    body: "Kamu bertanggung jawab atas ketepatan data yang kamu masukkan ke dalam aplikasi, serta menjaga kerahasiaan informasi login akunmu. Hasil perhitungan sangat bergantung pada data yang dimasukkan.",
  },
  {
    title: "7. Sifat Hasil Perhitungan",
    body: "Seluruh hasil perhitungan HPP, harga jual, margin, dan BEP bersifat sebagai alat bantu pengambilan keputusan. KalkuBisnis tidak menjamin keuntungan, kelancaran, atau kesuksesan usaha. Hasil usaha tetap bergantung pada ketepatan data, harga pasar, biaya, penjualan, dan keputusan yang kamu ambil.",
  },
  {
    title: "8. Ketersediaan Layanan",
    body: "Ketersediaan layanan dapat bergantung pada layanan hosting, pemeliharaan teknis berkala, dan infrastruktur pendukung lainnya. Kami berupaya menjaga layanan tetap berjalan dengan baik, namun gangguan sementara dapat terjadi.",
  },
];

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-white">
      <header className="border-b border-slate-200/70 bg-white/85 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="terms-logo-link" aria-label="Kembali ke beranda KalkuBisnis">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="terms-back-link"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 transition-colors hover:text-teal-700"
          >
            <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            Kembali
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Syarat dan Ketentuan KalkuBisnis
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          Dengan membeli dan menggunakan KalkuBisnis, kamu menyetujui ketentuan berikut. Kami
          menuliskannya dengan bahasa yang sederhana supaya mudah dipahami.
        </p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-base font-semibold text-slate-900 sm:text-lg">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>
        <div className="mt-12 rounded-2xl border border-teal-200/70 bg-teal-50 p-5">
          <p className="text-sm leading-relaxed text-slate-700">
            Ada pertanyaan tentang ketentuan ini? Silakan hubungi kami melalui kanal resmi yang
            tercantum pada halaman pembelian Mayar.
          </p>
        </div>
      </main>
      <footer className="border-t border-slate-200 py-6">
        <p className="text-center text-xs text-slate-500">
          © {new Date().getFullYear()} KalkuBisnis. Seluruh hak cipta dilindungi.
        </p>
      </footer>
    </div>
  );
}
